import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
export function getHttpClient() {
  var optHeaders = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function request(_ref) {
    var url = _ref.url,
      _ref$method = _ref.method,
      method = _ref$method === void 0 ? 'GET' : _ref$method,
      body = _ref.body,
      params = _ref.params;
    var uri = new URL(url);
    if (params) {
      Object.keys(params).filter(function (k) {
        return params[k];
      }).forEach(function (key) {
        return uri.searchParams.append(key, params[key]);
      });
    }
    return fetch(uri, {
      method: method,
      headers: _objectSpread({
        'Content-Type': 'application/json',
        Accept: 'application/json'
      }, optHeaders),
      body: JSON.stringify(body)
    });
  };
}